import React from 'react';
import RenterSearch from '../components/search/RenterSearch';

function RenterSearchPage() {
    return <RenterSearch />;
}

export default RenterSearchPage; 